<template>
  <v-row>
    <v-col cols="auto">
      <v-text-field
        v-model="textValue"
        label="Sitzplatz"
        density ="compact"
        variant="solo"
        hide-details
        readOnly
        clearable
        @click:clear="handleClear"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
  export default {

  data(){
    return {
      textValue: ''
    }
  },
  props: {
    calendarInfoLabelSeat: {type: Object, default: null}  
  },

  emits: ['cleared'],

  watch: {
    calendarInfoLabelSeat() {
      this.getSeatDescription()
    },
  },

  methods: {
    getSeatDescription(){
      if (!this.calendarInfoLabelSeat) return
        this.textValue = this.calendarInfoLabelSeat.room + '-Platz ' + this.calendarInfoLabelSeat.name
    },

    handleClear() {
      this.textValue = ''
      this.$emit('cleared')
    }

  }
};
</script>

<style scoped>

.v-text-field {
  color: black;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
  font-size: large;
  font-weight: normal !important;
  border-radius: 4px;
  min-width: 22rem;
  width: auto;
}
</style>